import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useModuleStore } from '../enrollment-process/module-management/model/ModuleStoreHook';
import { EnrollmentOrderInfo } from './EnrollmentOrderInfo';
import { SocialLinkExpiredModal } from './SocialLinkExpiredModal';
import { useRootStore } from '../root/RootStoreHooks';
import { MinimumPvWarningModal } from './creator-mode/MinimumPvWarningModal';
import { MeoWarning, WarningReasonType } from '../order-selection/er-kit-selection/MeoWarning';
import { ERAgreementEntry } from '../customer-information/er-agreement/ERAgreementEntry';
import { ERAgreementStore } from '../customer-information/er-agreement/ERAgreementStore';

export const SocialLinkEntry = observer(() => {
  const store = useModuleStore('socialLinkEntry');
  const rootStore = useRootStore();
  const meoStore = rootStore.moduleStores.meoKitSelection!;
  const { t } = useTranslation();

  useEffect(() => {
    meoStore?.toggleWarningMessage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { enrollerId, enrollerFullName } = store.referrerReview!;

  return (
    <div className="container">
      <h2 className="text-primary">{t('SocialLinkEntry_FriendshipMatters')}</h2>
      <h5>
        <strong>{t('SocialLinkEntry_Welcome')}</strong>
      </h5>
      <div>
        {enrollerFullName} (member #{enrollerId}) {t('SocialLinkEntry_Content')}
      </div>
      <EnrollmentOrderInfo orderInfo={store.enrollmentOrderInfo!} isMeoMarket={store.isMeoMarket}
      minimumEnrollmentOrderPVreached={store.isMinimumEnrollmentPvReached}
      minimumERPVReached ={store.isMinimumErPvReached} />
      <SocialLinkExpiredModal show={rootStore.enrollmentStatus.socialLinkHasExpired} />
      {meoStore?.orderRequiredModal ? (
        //using meo warnings in CEO countries and default one in other
        <MeoWarning
          type={WarningReasonType.EnrollmentOrderUnderPV}
          minimumEnrollmentPv={store.minimumEnrollmentOrderPv}
          minimumErPv={store.enrollmentOrderInfo!.minimumErPv}
        />
      ) : (
        <MinimumPvWarningModal
          show={store.showMinimumPvWarning}
          content="MinimumPvEnroleeWarningModal_Content"
          minimumPv={store.enrollmentOrderInfo!.minimumErPv}
          currentPv={store.enrollmentOrderInfo!.currentPv}
          onClose={() => store.updateMinimumPvWarning(false)}
        />
      )}

      {store.showErAgreementModel && (
        <ERAgreementEntry
          store={ERAgreementStore.create({
            showmodel: store.showErAgreementModel,
            isErAgreementDismissible: store.isErAgreementDismissible || false
          })}
        />
      )}
    </div>
  );
});
